import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const token = localStorage.getItem('authToken');
  const [loading, setLoading] = useState(true);

  // Prevent duplicate /auth/me calls
  const fetchedRef = useRef(false);

  const logout = useCallback(() => {
    setUser(null);
    fetchedRef.current = false;

    localStorage.removeItem('authToken');
  }, []);

  const fetchUser = useCallback(async () => {
    try {
      const { data } = await axios.get('/auth/me');
      setUser(data);
    } catch (error) {
      logout(); // token invalid or expired
    }
  }, [logout]);

  useEffect(() => {
    const storedToken = localStorage.getItem('authToken');

    if (storedToken) {
      // Call /auth/me only once per refresh
      if (!fetchedRef.current) {
        fetchedRef.current = true;
        fetchUser().finally(() => setLoading(false));
      }
    } else {
      setLoading(false);
    }
  }, [fetchUser]);

  const isAuthenticated = !!token;

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        isAuthenticated,
        logout,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
